var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M852.688 143.817L806.6 143.817L806.6 290.205L852.688 290.205C859.048 290.205 864.209 283.647 864.209 275.566L864.209 158.455C864.209 150.375 859.048 143.817 852.688 143.817L852.688 143.817Z",
    fill: "#f17a7a",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.84 290.205L808.752 290.205L808.752 436.594L854.84 436.594C861.2 436.594 866.361 430.036 866.361 421.955L866.361 304.844C866.361 296.764 861.2 290.205 854.84 290.205L854.84 290.205Z",
    fill: "#f9b37b",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.227 436.594L807.14 436.594L807.14 582.983L853.227 582.983C859.587 582.983 864.749 576.425 864.749 568.344L864.749 451.233C864.749 443.152 859.587 436.594 853.227 436.594L853.227 436.594Z",
    fill: "#fff283",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.227 582.983L807.14 582.983L807.14 729.372L853.227 729.372C859.587 729.372 864.749 722.813 864.749 714.733L864.749 597.622C864.749 589.541 859.587 582.983 853.227 582.983L853.227 582.983Z",
    fill: "#8af291",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.857 912L247.857 112L795.082 112C800.42 112 808.752 121.12 808.752 127.429L808.752 896.571C808.752 902.88 800.42 912 795.082 912L247.857 912Z",
    fill: "#60baff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.526 912C174.901 912 166.336 902.88 166.336 896.571L166.336 127.429C166.336 121.12 174.901 112 180.526 112L247.857 112L247.857 912L180.526 912Z",
    fill: "#046bc6",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.183 226.131L654.099 226.131C683.46 226.131 707.262 249.975 707.262 279.388L707.262 539.701C707.262 569.115 683.46 592.959 654.099 592.959L399.183 592.959C369.822 592.959 346.02 569.115 346.02 539.701L346.02 279.388C346.02 249.975 369.822 226.131 399.183 226.131Z",
    fill: "#848484",
    fillOpacity: 0.637387,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.04 464.466C381.04 435.872 408.114 418.375 428.632 416.499L464.761 414.2C475.474 413.518 492.859 412.948 503.593 412.928L552.284 412.833C563.018 412.812 580.399 413.41 591.107 414.169L623.988 416.499C649.702 418.375 671.58 435.872 671.58 464.466L677.335 571.653C677.911 582.372 669.676 591.061 658.941 591.061L393.678 591.061C382.944 591.061 374.709 582.372 375.285 571.653L381.04 464.466Z",
    fill: "#046bc6",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.22 266.646L528.389 266.646C569.726 266.646 603.237 301.066 603.237 343.526L603.237 343.526C603.237 385.985 569.726 420.405 528.389 420.405L525.22 420.405C483.883 420.405 450.372 385.985 450.372 343.526L450.372 343.526C450.372 301.066 483.883 266.646 525.22 266.646Z",
    fill: "#ffdfab",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.483 368.309L527.141 368.309C548.775 368.309 566.312 388.292 566.312 412.942L566.312 412.942C566.312 437.592 548.775 457.574 527.141 457.574L525.483 457.574C503.849 457.574 486.312 437.592 486.312 412.942L486.312 412.942C486.312 388.292 503.849 368.309 525.483 368.309Z",
    fill: "#ffdfab",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameTable);
export default __webpack_public_path__ + "static/media/NameTable.d5bc3a59ebc57ad0d00c1c3e4d3dbe46.svg";
export { ForwardRef as ReactComponent };